<script setup lang="ts">
import NotificationSettingRow from '@/components/AccountParts/NotificationSettingRow.vue';
import AccountNotificationSettingsType from '@/types/AccountNotificationSettings';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import { computed, ref, onMounted } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
  modelValue: AccountNotificationSettingsType
  outputDataAuthority: boolean
  temperatureAuthority: boolean
}>();

const isAll = ref(false)

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

onMounted(() => {
  checkAllStatuses();
});

function changeAllStatus(bool: boolean) {
  Object.keys(modelValue.value).forEach((key: string) => {
    Object.keys(modelValue.value[key]).forEach((setting: string) => {
      modelValue.value[key][setting] = bool;
    });
  });
}

function checkAllStatuses() {
  let isAllStatusesTrue = true;
  Object.keys(modelValue.value).forEach((key: string) => {
    Object.keys(modelValue.value[key]).forEach((setting: string) => {
      if (!modelValue.value[key][setting]) {
        isAllStatusesTrue = false;
      }
    });
  });
  isAll.value = isAllStatusesTrue;
}

function clickToggleSwitch(bool: boolean) {
  changeAllStatus(bool)
}

</script>
<template>
  <v-row
    class="text-form px-3 pt-4 d-flex"
  >
    <h6 class="pt-2 pl-2">
      {{ i18n.global.t('pages.accounts.form.notificationSettings.all') }}
    </h6>
    <ToggleSwitch
      class="ml-6"
      v-model="isAll"
      @click="clickToggleSwitch(!isAll)"
    />
  </v-row>
  <NotificationSettingRow
    :title="i18n.global.t('pages.accounts.form.notificationSettings.riskyDriving.title')"
    :keyName="'riskyDriving'"
    v-model="modelValue.riskyDriving"
    @change="checkAllStatuses"
  />
  <NotificationSettingRow
    :title="i18n.global.t('pages.accounts.form.notificationSettings.cvrUpload.title')"
    :keyName="'cvrUpload'"
    v-model="modelValue.cvrUpload"
    @change="checkAllStatuses"
  />
  <NotificationSettingRow
    v-if="props.temperatureAuthority"
    :title="i18n.global.t('pages.accounts.form.notificationSettings.temperature.title')"
    :keyName="'temperature'"
    v-model="modelValue.temperature"
    @change="checkAllStatuses"
  />
  <NotificationSettingRow
    v-if="props.outputDataAuthority"
    :title="i18n.global.t('pages.accounts.form.notificationSettings.outputData.title')"
    :keyName="'outputData'"
    v-model="modelValue.outputData"
    @change="checkAllStatuses"
  />
</template>
